import React from "react";

const DevicePumps: React.FC<any> = ({devicePumps }) => { 
  return (
    <div className="border-darkcolor-400 border-[1px] rounded-[4px] flex flex-col items-start bg-gradient-to-b from-[#253240] via-[#253240] to-[rgba(37, 48, 64, 0.40)] mb-[12px] card">
      <div className="w-full grow px-6 pt-4 pb-4 cardHeader">
        <label className="text-neutral-25 text-[16px] font-bold leading-[24px] ">
          Pump details
        </label>
      </div>
      <div className="relative w-full h-full text-neutral-25 py-[6px] px-6 cardBody sitestable">
        <ul className="list-none">
          <li className="py-[10px] mb-1">
            <div className="text-base">
              Manufacturer:
              <label className="ml-2 text-base text-primary-400">
                {devicePumps && devicePumps?.manufacturer}
              </label>
            </div>
          </li>
          {/* <li className="py-[10px] mb-1">
            <div className="text-base">
              Model:
              <label className="ml-2 text-base text-primary-400">
                {devicePumps && devicePumps?.model}
              </label>
            </div>
          </li> */}
          <li className="py-[10px] mb-1">
            <div className="text-base">
              Control type:
              <label className="ml-2 text-base text-primary-400">
                {devicePumps && devicePumps?.controlType}
              </label>
            </div>
          </li>
          <li className="py-[10px] mb-1">
            <div className="text-base">
              Power type:
              <label className="ml-2 text-base text-primary-400">
                {devicePumps && devicePumps?.powerType}
              </label>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default DevicePumps;
